import { IMenuStateTotals } from '../../interfaces/menu';

export const setMenuTotals = (payload: IMenuStateTotals) : any => {
    return {
        type: 'SET_MENU_TOTALS',
        payload
    };
};